import { FieldConfigActionDispatch, FieldConfigReduxType } from "./types";

export const getFieldConfig=():FieldConfigActionDispatch =>({
    type: FieldConfigReduxType.GET_FIELD_CONFIG,
    payload:{}
})
